import { useState, useCallback, useEffect } from 'react'

import { TrackingEventTimelineGroup } from '../types/LiveEvents'
import { TrackingEventByGame } from '../types/TrackingEvents'
import { EventDialogTab } from './useEventDialogTabs'
import { useLiveEventTypeModal } from './useLiveEventTypeModal'

/**
 * Hook for opening event modal when LET calendar group is clicked.
 *
 * This is a a bit of hack but needs to be done like this because calendar does not necessarily update the event handlers
 * when location is changed e.g. it uses stale state to open the modal which causes issues like https://vungle.atlassian.net/browse/GR-2050 and https://vungle.atlassian.net/browse/GR-2049
 */
export const useLiveEventsCalendarGroupClickHandler = () => {
  const { showModal: showEventTypeModal } = useLiveEventTypeModal()
  const [selectedTrackingEventTimelineGroup, setSelectedTrackingEventTimelineGroup] = useState<TrackingEventTimelineGroup>()

  const handleCalendarEventGroupClick = useCallback((group: TrackingEventTimelineGroup) => {
    setSelectedTrackingEventTimelineGroup(group)
  }, [])

  useEffect(() => {
    const group = selectedTrackingEventTimelineGroup
    if (group) {
      setSelectedTrackingEventTimelineGroup(undefined)
      showEventTypeModal({ trackedGameId: group.trackedGame.game.id, eventTypeId: group.eventTypeId, tab: EventDialogTab.AllEvents })
    }
  }, [selectedTrackingEventTimelineGroup, showEventTypeModal])

  return handleCalendarEventGroupClick
}

export const useLiveEventsCalendarBlueprintClickHandler = (trackingEventsByGame?: TrackingEventByGame) => {
  const { showModal: showEventTypeModal } = useLiveEventTypeModal()
  const [selectedTrackingEventTimelineGroup, setSelectedTrackingEventTimelineGroup] = useState<TrackingEventTimelineGroup>()

  const handleCalendarEventGroupClick = useCallback((group: TrackingEventTimelineGroup) => {
    setSelectedTrackingEventTimelineGroup(group)
  }, [])

  useEffect(() => {
    const group = selectedTrackingEventTimelineGroup
    if (group) {
      setSelectedTrackingEventTimelineGroup(undefined)

      // Find a representative event from this blueprint group
      // We need to get the most recent event from this event type and blueprint
      const gameEvents = trackingEventsByGame?.[group.trackedGame.game.id] || []
      const matchingEvent = gameEvents.find((event) => event.typeId === group.eventTypeId && event.blueprintEvolutionData?.blueprintId === group.blueprintId)

      showEventTypeModal({
        trackedGameId: group.trackedGame.game.id,
        eventTypeId: group.eventTypeId,
        tab: EventDialogTab.LiveEventEvolution,
        eventId: matchingEvent?.eventId,
      })
    }
  }, [selectedTrackingEventTimelineGroup, showEventTypeModal, trackingEventsByGame])

  return handleCalendarEventGroupClick
}
